import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import {
  API_ENDPOINTS,
  DEFAULT_PAGE_START,
  COOKIE_SET_TIMER,
  COOKIES_KEY,
} from '../Utils/constants'
import { COOKIE_STOAGE } from '../Utils/Storage'

export default class GalleryStore extends FetchBase {
  @observable spaceAttachments = []
  @observable spaceAttachmentsLoader = false

  @observable spacePanelSearchText = ''
  @observable spacePanels = []
  @observable spacePanelsLoader = false
  @observable rotateLoader = false

  @action.bound
  setSpacePanelSearchText = (value = '') => {
    this.spacePanelSearchText = value
  }

  @action.bound
  getFiltersForSpacePanels = () => {
    let temp = {}
    this.spacePanelSearchText && (temp['search'] = this.spacePanelSearchText)
    return temp
  }

  @action.bound
  getSpacePanels = async (projectId, signal) => {
    try {
      this.spacePanelsLoader = true
      let filters = this.getFiltersForSpacePanels() || {}
      let response = await this.get(
        API_ENDPOINTS.SPACE_ATTACHMENTS,
        {
          projectId,
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.spacePanels = response.data || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.spacePanelsLoader = false
    }
  }

  @action.bound
  rotatedImageSave = async (id, degree) => {
    try {
      this.rotateLoader = true
      let response = await this.post(API_ENDPOINTS.ROTATE_IMAGE, {
        attachmentId: id,
        degree,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.rotateLoader = false
    }
  }

  @action.bound
  resetStore = () => {
    this.spaceAttachments = []
    this.spaceAttachmentsLoader = false
    this.spacePanelSearchText = ''
    this.spacePanels = []
    this.spacePanelsLoader = false
    this.rotateLoader = false
  }
}
